import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Assets
const photos = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=800&q=80",
    title: "STREETS",
    speed: 0.5,
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&w=800&q=80",
    title: "PORTRAITS",
    speed: 1.2,
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&w=800&q=80",
    title: "WILDLIFE",
    speed: 0.8,
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=800&q=80",
    title: "MOMENTS",
    speed: 1.5,
  },
];

gsap.registerPlugin(ScrollTrigger);

const SimpleGallery = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    let ctx = gsap.context(() => {
      // Create a parallax effect for each photo card
      gsap.utils.toArray(".photo-card").forEach((card, i) => {
        const speed = photos[i].speed;

        gsap.fromTo(
          card,
          { y: 100 * speed, opacity: 0 },
          {
            y: -100 * speed,
            opacity: 1,
            ease: "none",
            scrollTrigger: {
              trigger: card,
              start: "top bottom",
              end: "bottom top",
              scrub: true,
            },
          },
        );
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <GalleryContainer ref={containerRef}>
      <SectionHeader>
        <h3>COLLECTIONS</h3>
        <div className="line" />
      </SectionHeader>

      {photos.map((photo, index) => (
        <PhotoRow key={photo.id} isEven={index % 2 === 0}>
          <PhotoCard className="photo-card">
            <div className="img-wrapper">
              <img src={photo.url} alt={photo.title} />
            </div>
            <PhotoInfo>
              <span className="number">0{index + 1}</span>
              <h4 className="title">{photo.title}</h4>
            </PhotoInfo>
          </PhotoCard>
        </PhotoRow>
      ))}
    </GalleryContainer>
  );
};

export default SimpleGallery;

// --- Styled Components ---

const GalleryContainer = styled.section`
  background: #000;
  padding: 10vw 0;
  color: #fff;
`;

const SectionHeader = styled.div`
  padding: 0 10vw;
  margin-bottom: 10vh;
  h3 {
    font-size: 1rem;
    letter-spacing: 0.5em;
    opacity: 0.6;
  }
  .line {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
    margin-top: 10px;
  }
`;

const PhotoRow = styled.div`
  display: flex;
  width: 100%;
  padding: 0 10vw;
  justify-content: ${(props) => (props.isEven ? "flex-start" : "flex-end")};
  margin-bottom: -10vh; /* This creates the overlap effect */
  position: relative;
`;

const PhotoCard = styled.div`
  width: 35vw;
  position: relative;

  .img-wrapper {
    width: 100%;
    aspect-ratio: 4 / 5;
    overflow: hidden;
    border-radius: 2px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;
    }

    &:hover img {
      transform: scale(1.05);
    }
  }
`;

const PhotoInfo = styled.div`
  margin-top: 20px;
  .number {
    font-family: monospace;
    font-size: 0.8rem;
    color: #666;
  }
  .title {
    font-size: 2vw;
    margin: 5px 0;
    font-weight: 300;
    letter-spacing: 0.1em;
  }
`;
